export default __webpack_public_path__ + "static/media/graphic_design.e31f045a.png";